import React from "react";
import PropTypes from "prop-types";
// import Header2 from "../../components/header/Header2";
import Banner07 from "../../components/banner/Banner07";
import Category07 from "../../components/category/Category07";
import dataCate from "../../assets/fakeData/dataCategory";
import Job07 from "../../components/jobs/Job07";
import dataJobs from "../../assets/fakeData/dataJobs";
import Location from "../../components/location";
import dataLocation from "../../assets/fakeData/dataLocation";

import Box07 from "../../components/boxicon/Box07";
import Couter from "../../components/iconbox/Couter";
import Blog01 from "../../components/blog/Blog01";
import dataBlog from "../../assets/fakeData/dataBlog";
import Partner from "../../components/partner";
import dataPartner from "../../assets/fakeData/dataPartner";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import { useEffect } from "react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import MobileHeader from "../../components/header/MobileHeader";
import Job03 from "../../components/jobs/Job03";
import EmpSec5 from "../../components/employer/EmpSec5";
import dataEm from "../../assets/fakeData/dataEmployers";
import Employer from "../../components/employer";
import Job05 from "../../components/jobs/Job05";
// import Header03 from "../../components/header/Header03";
// import Header4 from "../../components/header/Header4";
import NonLoginHeader from "../../components/header/NonLoginHeader";
import LoginHeader from "../../components/header/LoginHeader";
import JobStyle4 from "../../components/jobs/JobStyle4";
import GetApp from "../../components/getapp";
import ReviewJob09 from "../../components/jobs/ReviewJob09";
import Banner01 from "../../components/banner/Banner01";
import Category from "../../components/category";
// import NonLoginMobileHeader from "../../components/header/NonLoginMobileHeader";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";


const CandidateHome = () => {

  const [isShowMobile, setShowMobile] = useState(false);



  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  return (
    <>
      <LoginMobileHeader handleMobile={handleMobile} />
      <LoginHeader clname="act1" handleMobile={handleMobile} />
      <Banner01 />
      <Category data={dataCate} title= "Browse by category"  text= "Recruitment Made Easy in 100 seconds" /> 
      <Job03  className="jobs-section" />
      <Box07 />
      <div className="container">
      <Couter className="background1" />
      </div>
      <Employer data={dataEm} className="employer-section-two" /> 
      {/* <Blog01 data={dataBlog} className="news-section" /> */}
      <Partner data={dataPartner} />    
      <Footer />
      <Gotop />
    </>
  )
}

export default CandidateHome